"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyAccountCategory$ = exports.CompaniesCompanyAccountCategory$outboundSchema = exports.CompaniesCompanyAccountCategory$inboundSchema = exports.CompaniesCompanyAccountCategory = void 0;
const z = __importStar(require("zod"));
exports.CompaniesCompanyAccountCategory = {
    AccountsTypeNotAvailable: "ACCOUNTS TYPE NOT AVAILABLE",
    Dormant: "DORMANT",
    TotalExemptionSmall: "TOTAL EXEMPTION SMALL",
    TotalExemptionFull: "TOTAL EXEMPTION FULL",
    MicroEntity: "MICRO ENTITY",
    NoAccountsFiled: "NO ACCOUNTS FILED",
    Full: "FULL",
    AuditExemptionSubsidiary: "AUDIT EXEMPTION SUBSIDIARY",
    Small: "SMALL",
    AuditedAbridged: "AUDITED ABRIDGED",
    FilingExemptionSubsidiary: "FILING EXEMPTION SUBSIDIARY",
    Group: "GROUP",
    PartialExemption: "PARTIAL EXEMPTION",
    Medium: "MEDIUM",
    UnauditedAbridged: "UNAUDITED ABRIDGED",
    Initial: "INITIAL",
};
/** @internal */
exports.CompaniesCompanyAccountCategory$inboundSchema = z.nativeEnum(exports.CompaniesCompanyAccountCategory);
/** @internal */
exports.CompaniesCompanyAccountCategory$outboundSchema = exports.CompaniesCompanyAccountCategory$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyAccountCategory$;
(function (CompaniesCompanyAccountCategory$) {
    /** @deprecated use `CompaniesCompanyAccountCategory$inboundSchema` instead. */
    CompaniesCompanyAccountCategory$.inboundSchema = exports.CompaniesCompanyAccountCategory$inboundSchema;
    /** @deprecated use `CompaniesCompanyAccountCategory$outboundSchema` instead. */
    CompaniesCompanyAccountCategory$.outboundSchema = exports.CompaniesCompanyAccountCategory$outboundSchema;
})(CompaniesCompanyAccountCategory$ || (exports.CompaniesCompanyAccountCategory$ = CompaniesCompanyAccountCategory$ = {}));
//# sourceMappingURL=companiescompanyaccountcategory.js.map